import { Component } from '@angular/core';
import { TranslationService } from '../../translations';

@Component({
    template: `
        <basic-page-layout>
            <!--tablistclassmodifiers borrowed from admin temporarily-->
            <ng-container page-header-title>
                <span data-testing="subscription-manager-page-header">
                    {{ this.TR.key('subscription-manager.page-title') }}
                </span>
            </ng-container>
            <ng-container page-main-body>
                <loading-dots
                    [ngStyle]="{
                        display: loading ? 'block' : 'none'
                    }"
                ></loading-dots>
                <account-subscription-overview-component
                    [ngStyle]="{
                        display: !loading ? 'block' : 'none'
                    }"
                    (initComplete)="updateLoadingState($event)"
                ></account-subscription-overview-component>
            </ng-container>
        </basic-page-layout>
    `,
    standalone: false
})
export class AccountSubscriptionManagerPage {
    loading = true;

    constructor(public TR: TranslationService) {}

    updateLoadingState(initComplete: boolean) {
        this.loading = !initComplete;
    }
}
